<template>
  <div data-app>
    <div class="flex-vertical photo-area-container">
      <div class="flex-vertical photo-container">
        <div
          v-if="photoUploaded"
          class="photo-image fill-space"
          @click="openImageDialog"
        >
          <img
            :src="getPhotoWithBase64(selectedPhoto.image_thumb)"
            alt="photo"
            class="photo fill-space"
          />
        </div>
        <div
          v-if="photoUploaded && !disabled"
          class="flex-vertical photo-options"
        >
          <MenuButton
            class="photo-options-button"
            @click="hoverMenu = !hoverMenu"
          />
          <photo-menu
            v-show="hoverMenu"
            @updateImage="onFileChange"
            @removeImage="tryToDeletePhoto"
          />
        </div>
        <div
          v-if="!photoUploaded"
          class="input-container fill-space"
          :class="{ disabled: disabled }"
          :style="{ 'background-image': `url(${photoIcon})` }"
          @change="onFileChange"
        >
          <input
            class="photo-input fill-space"
            type="file"
            accept="image/*"
            title
            :disabled="disabled"
          />
        </div>
      </div>
      <div class="photo-name">{{ imageData.label }}</div>
    </div>

    <photo-opened
      v-if="imageDialog"
      :imageData="imageData"
      :image="selectedPhoto.image"
      :thumb="selectedPhoto.image_thumb"
      :description="selectedPhoto.description"
      :uuid="selectedPhoto.uuid"
      :disabled="disabled"
      :photoCanBeClosed="photoCanBeClosed"
      @removeImage="tryToDeletePhoto"
      @close="closeImageDialog"
      @updateDescription="updateDescription"
    />

    <photo-upload-error
      :toggleDialog="uploadErrorDialog"
      :specificErrorMessage="$t(specificErrorMessage)"
    />

    <app-dialog-box
      :open="deleteDialogIsOpen"
      :title="$t('DeletePhoto')"
      :content="$t('DeletePhotoConfirmation')"
      :main-action-label="$t('Yes')"
      @mainAction="removeImage"
      :secondary-action-label="$t('No')"
      @secondaryAction="deleteDialogIsOpen = false"
    />
  </div>
</template>

<script>
import photoIcon from "@/assets/home/photosForm/photo.png";
import MenuButton from "@/assets/home/photosForm/more_menu.svg";
import PhotoMenu from "./PhotoMenu";
import PhotoOpened from "./PhotoOpened";
import PhotoUploadError from "./PhotoUploadError";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
export default {
  name: "PhotoField",

  components: {
    MenuButton,
    PhotoMenu,
    PhotoOpened,
    PhotoUploadError,
    AppDialogBox
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    imageData: {
      type: Object,
      required: true
    },
    previousPhoto: {
      type: Object | undefined,
      required: true
    }
  },

  data() {
    return {
      selectedPhoto: {
        name: "",
        image: "",
        image_thumb: "",
        description: ""
      },
      hoverPhoto: false,
      hoverMenu: false,
      uploadErrorDialog: false,
      specificErrorMessage: "",
      imageDialog: false,
      photoIcon,
      deleteDialogIsOpen: false,
      photoCanBeClosed: false
    };
  },
  computed: {
    photo() {
      let photo;
      if (this.previousPhoto !== undefined) {
        photo = this.previousPhoto;
      } else
        photo = {
          name: "",
          image: "",
          image_thumb: "",
          description: ""
        };
      this.selectedPhoto = photo;
      return photo;
    },
    photoUploaded() {
      return this.selectedPhoto.image_thumb !== "";
    }
  },

  methods: {
    onFileChange(e) {
      this.hoverMenu = false;
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      this.photoCanBeClosed = false;
      if (file.type.includes("image")) {
        let reader = new FileReader();

        reader.onload = e => {
          this.selectedPhoto.image = e.target.result;
          this.selectedPhoto.image_thumb = e.target.result;
          this.$emit("updatePhoto", {
            name: this.imageData.varName,
            photo: e.target.result
          });
        };
        reader.readAsDataURL(file);
      } else {
        this.specificErrorMessage = "ChooseImageFile";
        this.uploadErrorDialog = true;
      }
    },
    tryToDeletePhoto() {
      this.deleteDialogIsOpen = true;
    },
    removeImage() {
      this.selectedPhoto = {
        name: "",
        image: "",
        image_thumb: "",
        description: ""
      };
      this.deleteDialogIsOpen = false;
      this.photoCanBeClosed = true;
      this.hoverMenu = false;
      if (this.previousPhoto !== undefined) {
        this.$emit("removePhoto", this.previousPhoto);
      } else {
        this.$emit("removePhoto", this.imageData.varName);
      }
    },
    closeErrorDialog() {
      this.uploadErrorDialog = false;
      this.specificErrorMessage = "";
    },
    openImageDialog() {
      this.hoverMenu = false;
      this.imageDialog = true;
    },
    closeImageDialog() {
      this.imageDialog = false;
    },
    getPhotoWithBase64(image) {
      if (
        image.includes("data:image/jpeg;base64,") ||
        image.includes("data:image/png;base64,")
      ) {
        return image;
      } else return "data:image/jpeg;base64," + image;
    },
    updateDescription(description) {
      this.selectedPhoto.description = description;
      this.$emit("updatePhoto", {
        name: this.imageData.varName,
        description: description
      });
    }
  },
  watch: {
    photo(value) {
      this.selectedPhoto = value;
    }
  }
};
</script>

<style scoped>
.input-container {
  border: 1px solid var(--secondary-lighter);
  display: flex;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-color: #ffffff;
}
.input-container.disabled:hover {
  background-color: #ffffff;
}

.input-container:hover {
  background-color: #f0f0f0;
}

.photo-options-button{
position: absolute;
top: 0px;
right: 0px;
margin-top:0px;
margin-right:2px;
}


</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Photos/PhotoField.vue